import { Box, Container, ContainerProps } from "@mui/material";
import { FC } from "react";
import { ContainerSize } from "src/lib/utils/types";

interface SalifyContainerWrapperProps extends ContainerProps {
  containerSize: ContainerSize | undefined;
}

export const SalifyContainerWrapper: FC<SalifyContainerWrapperProps> = ({
  containerSize,
  ...props
}) => {
  return containerSize === "full" || !containerSize ? (
    <Box>{props.children}</Box>
  ) : (
    <Container disableGutters maxWidth={containerSize} {...props}>
      {props.children}
    </Container>
  );
};
